'use client'; import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, XCircle, X } from 'lucide-react';
import { Button } from "@/components/base/buttons/button";

const SubmissionStatus = ({ status, successMessage, errorMessage, onReset }) => {
    if (status === 'idle' || status === 'loading') return null;

    const isSuccess = status === 'success';

    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            className={`flex flex-col md:flex-row items-center md:items-start gap-4 p-6 rounded-xl border transition-colors duration-300 ${isSuccess
                ? 'bg-success-50/50 dark:bg-success-950/20 border-success-100 dark:border-success-900/50'
                : 'bg-error-50/50 dark:bg-error-950/20 border-error-100 dark:border-error-900/50'
                }`}
        >

            <div className={`shrink-0 p-2 rounded-full ${isSuccess
                ? 'bg-success-100 dark:bg-success-900/30 text-success-600 dark:text-success-400'
                : 'bg-error-100 dark:bg-error-900/30 text-error-600 dark:text-error-400'
                }`}>
                {isSuccess
                    ? <CheckCircle size={24} className="text-current" />
                    : <XCircle size={24} className="text-current" />
                }
            </div>

            <div className="flex-1 text-center md:text-left">
                <h3 className={`text-base font-bold mb-1 ${isSuccess
                    ? 'text-success-900 dark:text-success-100'
                    : 'text-error-900 dark:text-error-100'
                    }`}>
                    {isSuccess ? 'Success!' : 'Something went wrong'}
                </h3>
                <p className={`${isSuccess
                    ? 'text-success-700 dark:text-success-400'
                    : 'text-error-700 dark:text-error-400'} text-sm leading-relaxed`}>
                    {isSuccess ? successMessage : errorMessage || "We couldn't process your request. Please try again."}
                </p>
            </div>

            {onReset && (
                <Button
                    color="tertiary"
                    size="sm"
                    iconLeading={X}
                    onClick={onReset}
                    className={`shrink-0 w-8 h-8 rounded-full transition-colors ${isSuccess
                        ? 'text-success-500 hover:text-success-700 hover:bg-success-100 dark:hover:bg-success-900/40'
                        : 'text-error-500 hover:text-error-700 hover:bg-error-100 dark:hover:bg-error-900/40'
                        }`}
                    aria-label="Close"
                />
            )}
        </motion.div>
    );
};

export default SubmissionStatus;
